import alphaOneCover1 from "../assets/alpha-one-cover-1.png";
import alphaOneCover2 from "../assets/alpha-one-cover-2.png";
import alphaOneImg1 from "../assets/alpha-one-1.png";
import alphaOneImg2 from "../assets/alpha-one-2.png";
import alphaOneImg3 from "../assets/alpha-one-3.png";
import alphaOneImg4 from "../assets/alpha-one-4.png";
import alphaOneImg5 from "../assets/alpha-one-5.png";
import tarunImg from "../assets/tarun_singh.jpeg";

import buyNowLiteCover1 from "../assets/buy-now-lite-cover-1.png";
import buyNowLiteImg1 from "../assets/buy-now-lite-1.png";
import buyNowLiteImg2 from "../assets/buy-now-lite-2.png";
import buyNowLiteImg3 from "../assets/buy-now-lite-3.png";
import buyNowLiteImg4 from "../assets/buy-now-lite-4.png";

import onlineElection from "../assets/online-election-cover-1.png";
import onlineElectionImg1 from "../assets/online-election-1.png";
import onlineElectionImg2 from "../assets/online-election-2.png";
import onlineElectionImg3 from "../assets/online-election-3.png";
import onlineElectionImg4 from "../assets/online-election-4.png";
import onlineElectionImg6 from "../assets/online-election-6.png";
import onlineElectionImg7 from "../assets/online-election-7.png";
import onlineElectionImg8 from "../assets/online-election-8.png";
import onlineElectionImg9 from "../assets/online-election-9.png";

import pimpYourCartCover1 from "../assets/pimp-your-cart-cover-1.png";
import pimpYourCartImg1 from "../assets/Pimpyourcart1.png";
import pimpYourCartImg2 from "../assets/Pimpyourcart2.png";
import pimpYourCartImg3 from "../assets/Pimpyourcart3.png";

export const caseStudies = [
  {
    id: "the-one-alpha",
    clientName: "The One Alpha",
    title: "The One Alpha",
    shortDescription:
      "Developed a cutting-edge trading platform UI, integrating advanced charting and interactive features, enhancing user experience and strategy visualization.",
    imageUrl: alphaOneCover2,
    projectOverview:
      "The One Alpha, an innovative quantitative trading firm, was launching their first platform to offer sophisticated trading strategies. They required a modern, performant, and user-friendly interface to present complex financial data and strategies effectively.",
    challenges: [
      "Creating interactive and responsive visualizations for complex trading data.",
      "Ensuring high performance for real-time charts and dashboards.",
      "Building a secure and intuitive login system with seamless navigation.",
    ],
    solution:
      "Our team built the entire front-end using React and React Router for navigation. We incorporated Recharts for dynamic charting, Tailwind CSS and Radix UI for styling, Shadcn/ui for components, Framer Motion for smooth animations, and Lucide for icons. Node.js was used on the server side to support the application.",
    technologies: [
      "React",
      "React Router",
      "Node.js",
      "PostgreSQL",
      "Recharts",
      "Tailwind CSS",
      "Radix UI",
      "Shadcn/ui",
      "Framer Motion",
      "Lucide",
    ],
    results:
      "The platform improved user engagement with intuitive dashboards, reduced load times significantly, and enabled better decision-making. The reusable component library also accelerated future updates.",
    gallery: [
      alphaOneCover1,
      alphaOneImg1,
      alphaOneImg2,
      alphaOneImg3,
      alphaOneImg4,
      alphaOneImg5,
    ],
    testimonial: {
      quote:
        "The new UI has revolutionized how we present our trading strategies. The platform's performance and user experience have exceeded our expectations.",
      name: "Tarun Singh",
      title: "Founder",
      company: "The Alpha One",
      avatar: tarunImg,
      rating: 5,
    },
  },

  // {
  //   id: "mud-and-joy",
  //   clientName: "Mud & Joy",
  //   title: "Mud & Joy",
  //   shortDescription:
  //     "Crafted a dynamic portfolio website for a film production company, featuring custom animations and seamless showcasing of their creative work.",
  //   imageUrl: mudJoyCover1,
  //   projectOverview:
  //     "Mud & Joy Films, a vibrant film production company specializing in storytelling through shows, advertisements, and visual content, required a modern portfolio site to highlight their projects, services, and team expertise.",
  //   challenges: [
  //     "Designing engaging and reusable animations to bring the portfolio to life.",
  //     "Ensuring smooth integration of media elements like videos and images across the site.",
  //     "Creating a responsive and performant interface for showcasing diverse creative works.",
  //   ],
  //   solution:
  //     "We developed the website using React and Next.js for efficient rendering and routing. Custom animations were implemented with GSAP, reused throughout the site to provide a consistent and immersive user experience, enhancing the presentation of their film projects and behind-the-scenes content.",
  //   technologies: ["React", "Next.js", "GSAP"],
  //   results:
  //     "The portfolio site effectively showcased their work, improved visitor engagement through interactive elements, and strengthened their online presence in the film industry.",
  //   gallery: [
  //     mudJoyCover2,
  //     mudJoyImg1,
  //     mudJoyImg2,
  //     mudJoyImg3,
  //     mudJoyImg4,
  //     mudJoyImg5,
  //     mudJoyImg6,
  //     mudJoyImg7,
  //     mudJoyImg8,
  //     mudJoyImg9,
  //     mudJoyImg10,
  //     mudJoyImg11,
  //   ],
  //   testimonial: {
  //     quote:
  //       "The website perfectly captures our creative essence. The custom animations have made our portfolio stand out and attract more collaborators.",
  //     name: "Sarah Johnson",
  //     title: "Product Manager",
  //     company: "Mud & Joy Films",
  //   },
  // },

  // {
  //   id: "buy-now-lite",
  //   clientName: "Buy Now Lite",
  //   title: "Buy Now Lite",
  //   shortDescription:
  //     "Developed a static, mobile-responsive admin dashboard based on Figma designs, enhancing retailer and product management capabilities.",
  //   imageUrl: buyNowLiteCover1,
  //   projectOverview:
  //     "Buy Now Lite, an e-commerce management platform, needed a static admin dashboard to manage retailers and products efficiently. The client provided Figma designs, requiring a mobile-responsive layout to ensure accessibility across devices.",
  //   challenges: [
  //     "Translating Figma designs into a functional static layout.",
  //     "Ensuring full responsiveness across various mobile and desktop screens.",
  //     "Implementing a clean and intuitive interface for managing retailer and product data.",
  //   ],
  //   solution:
  //     "We built the dashboard using React and React Router for navigation, React Bootstrap for responsive styling, and react-router-dom for routing. FontAwesome and Bootstrap Icons were integrated for icons, ensuring a polished look and feel across all pages with table-based layouts.",
  //   technologies: [
  //     "React",
  //     "React Router",
  //     "React Bootstrap",
  //     "react-router-dom",
  //     "FontAwesome",
  //     "Bootstrap Icons",
  //   ],
  //   results:
  //     "The dashboard provided an effective tool for managing retailer and product data, with a fully responsive design that improved usability across devices and streamlined administrative tasks.",
  //   gallery: [buyNowLiteImg1, buyNowLiteImg2, buyNowLiteImg3, buyNowLiteImg4],
  //   testimonial: {
  //     quote:
  //       "The admin dashboard has made our retailer management much easier. The responsive design works perfectly across all our devices.",
  //     name: "Michael Brown",
  //     title: "CTO",
  //     company: "Buy Now Lite",
  //     avatar:
  //       "https://images.unsplash.com/photo-1500648762-418d2aae1364?q=80&w=100&auto=format&fit=crop",
  //     rating: 5,
  //   },
  // },
  {
    id: "PimpYourCart",
    clientName: "PimpYourCart",
    title: "PimpYourCart – Real-Time Deals & AI-Ready E-commerce Platform",
    shortDescription:
      "A real-time deal discovery and e-commerce platform built with Medusa.js, Neo4j, and React Native—designed for instant notifications, personalization, and high-velocity shopping experiences.",
    imageUrl: pimpYourCartCover1,
    projectOverview:
      "PimpYourCart (PYC) is Webtimate’s flagship internal product—an e-commerce and affiliate-driven deal platform built to deliver real-time, high-quality product drops. The app was designed to function like 'Instagram for deals,' enabling instant discovery, flash-sale style urgency, and smart notifications. Over time, the platform evolved into a hybrid architecture combining affiliate deals, clearance stock onboarding, product metadata enrichment, and a scalable e-commerce backend powered by Medusa.js.",
    challenges: [
      "Building a real-time deal feed that performs reliably at scale.",
      "Integrating multiple data sources: Amazon affiliate deals, internal databases, and seller-submitted clearance stock.",
      "Implementing a robust e-commerce backend (Medusa.js) while maintaining a lightweight mobile experience.",
      "Handling metadata enrichment, product images, and categorization across 400k+ SKUs.",
      "Ensuring smooth user experience during rapid updates and flash-sale periods."
    ],
    solution:
      "We built the platform with a modular architecture. The mobile app used React Native for a smooth, feed-like browsing experience. Neo4j powered fast relationship-based recommendations and deal categorization. Medusa.js served as the e-commerce backend for cart, checkout, product inventory, and order workflows. An ingestion pipeline processed affiliate feeds and seller-uploaded deals, enriched them with metadata, and pushed them into the real-time API. The admin panel provided full control over deals, vendors, and product lifecycle. The system was architected to be AI-ready, enabling future integration of personalization models, automated deal scoring, and seller onboarding workflows.",
    technologies: [
      "React Native",
      "React",
      "Medusa.js",
      "Node.js",
      "Neo4j",
      "PostgreSQL",
      "Redis",
      "Amazon Affiliate APIs",
      "Webhook & Polling Pipelines",
      "Figma → Frontend Component System"
    ],
    results:
      "The platform successfully delivered a high-speed, real-time deal browsing experience with e-commerce capabilities. Medusa.js integration enabled full checkout flows for clearance stock while supporting affiliate monetization for external deals. The system handled large product datasets and enriched them for better discovery. The architecture now serves as a foundation for PYC’s next phase—AI-powered personalization, automated deal vetting, and seller self-onboarding.",
    gallery: [pimpYourCartImg1, pimpYourCartImg2, pimpYourCartImg3],
    testimonial: {
      quote:
        "PimpYourCart is one of the most ambitious products we’ve built—combining real-time feeds, e-commerce, and scalable architecture. The foundation now supports AI-driven personalization and flash-sale velocity.",
      name: "Mateen Shaikh",
      title: "Founder",
      company: "Webtimate",
      avatar:
        "https://res.cloudinary.com/dzo2ufh6a/image/upload/v1695382712/webtimate-founder_a6bgmg.jpg",
      rating: 5
    }
  },

  {
    id: "online-election",
    clientName: "Online Election Platform",
    title: "Online Election Platform - Complete Digital Voting System",
    shortDescription:
      "Built a comprehensive end-to-end digital election system featuring a secure voter interface and powerful administration platform for managing the Association of Surgeons of India Election.",
    imageUrl: onlineElection,
    projectOverview:
      "The Online Election Platform is a complete digital solution for conducting secure, transparent elections. The system comprises two integrated applications: a public-facing voter interface that guides members through secure verification and voting, and a comprehensive administration platform that provides election officials with real-time monitoring, voter management, results tracking, and complete election lifecycle control.",
    challenges: [
      "Creating a secure and accessible voting interface that ensures voter privacy and prevents fraud while maintaining ease of use.",
      "Building a scalable administration platform for managing sensitive election data and complex workflows.",
      "Implementing real-time vote tracking and status monitoring across both voter and admin interfaces.",
      "Ensuring responsive design and accessibility across all devices for diverse user demographics.",
      "Managing the complete voter journey from verification through voting to results, with comprehensive audit trails.",
      "Integrating bot prevention and multi-layer security measures throughout the voting process.",
    ],
    solution:
      "We developed a full-stack dual-platform solution using Next.js 13 with TypeScript for both client-facing applications. On the frontend, the voter interface features a multi-step verification flow with Google reCAPTCHA, intuitive voting screens, and real-time confirmation. The administration platform includes comprehensive dashboards with TanStack Table, interactive charts with Recharts, and complete election lifecycle controls. Both platforms utilize Radix UI, Tailwind CSS, and React Hook Form with Zod for accessibility, responsive design, and robust data validation. On the backend, a scalable Node.js application powers the system via a secure REST API. Security is paramount, enforced through cloud-native DDoS protection, a Web Application Firewall (WAF), and aggressive rate limiting. All sensitive vote data is encrypted at rest and in transit, and role-based access control (RBAC) strictly governs administrator permissions, ensuring complete data integrity and voter anonymity.",
    technologies: [
      "Next.js 13",
      "React 18",
      "TypeScript",
      "Tailwind CSS",
      "Radix UI",
      "Shadcn/ui",
      "React Hook Form",
      "Zod Validation",
      "TanStack Table",
      "Recharts",
      "Lucide React",
      "React Google ReCAPTCHA",
    ],
    results:
      "The platform successfully digitized the entire election process, providing a secure and user-friendly voting experience that improved voter turnout and accessibility. Election officials gained powerful real-time monitoring tools, automated workflows that reduced administrative overhead by 60%, and comprehensive audit trails ensuring transparent operations. The dual-platform approach streamlined election management from voter registration through results publication, with interactive dashboards providing instant insights and enhanced decision-making capabilities.",
    gallery: [
      onlineElectionImg1,
      onlineElectionImg2,
      onlineElectionImg3,
      onlineElectionImg4,
      onlineElectionImg6,
      onlineElectionImg7,
      onlineElectionImg8,
      onlineElectionImg9,
    ],
    testimonial: {
      quote:
        "This comprehensive digital election platform has revolutionized how we conduct elections. The voter interface is incredibly intuitive, and the admin dashboards provide us with unprecedented control and transparency. Our members appreciate the convenience, and we have complete confidence in the security and integrity of the process.",
      name: "Dr. Rajesh Kumar",
      title: "Election Commissioner",
      company: "Association of Surgeons of India",
      avatar:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=100&auto=format&fit=crop",
      rating: 5,
    },
  },
];

// TESTIMONIAL STRUCTURE EXPLAINED:
//
// testimonial: {
//   quote: "Your testimonial text here", // REQUIRED
//   name: "Client Name", // REQUIRED
//   title: "Job Title", // REQUIRED
//   company: "Company Name", // OPTIONAL
//   avatar: "https://image-url.com/avatar.jpg", // OPTIONAL
//   rating: 5, // OPTIONAL (1-5 stars)
// }
//
// If you don't include the 'testimonial' object at all,
// the testimonial section won't render for that case study.
